import {baseRequestService} from "../base.ts";
import {EventApprover} from "../../types/domain.ts";

export const eventsEventIdApproversGet = (eventId: string) => baseRequestService<EventApprover[]>({
    url: `/events/${eventId}/approvers`,
    method: 'GET',
})